<template>
  <div class="general-tab">
    <!-- General tab -->
    <v-layout justify-space-between wrap>
      <v-flex sm4>
        <ArticlesTable />
      </v-flex>
      <v-flex sm8>
        <v-layout justify-space-between mb-4>
          <v-flex sm6>
            <h2>BLOC PROCESS</h2>
            <v-checkbox
              hide-details
              label="Fiche enregistrée admin"
              class="mr-4 mt-2 mb-2"
              v-model="project.idc_recorded_admin_file"
            ></v-checkbox>
            <h3 class="mb-0 mt-8">Essayage lancement Fabrication :</h3>
            <v-layout justify-space-between wrap mb-8>
              <v-checkbox
                v-model="project.idc_automatic_fitting1"
                hide-details
                label="Essayage 1"
                class="mr-4 mt-0"
                disabled
              ></v-checkbox>
              <v-checkbox
                v-model="project.idc_automatic_fitting2"
                hide-details
                label="Essayage 2"
                class="mr-4 mt-0"
                disabled
              ></v-checkbox>
              <v-checkbox
                v-model="project.idc_automatic_fitting3"
                hide-details
                label="Essayage 3"
                class="mt-0"
                disabled
              ></v-checkbox>
            </v-layout>
            <v-checkbox
              hide-details
              label="Finition de lancement Fab ate"
              class="mr-4 mt-2"
              v-model="project.idc_finishing"
              disabled
            ></v-checkbox>
            <v-checkbox
              hide-details
              label="Fiche imprimée"
              class="mr-4 mt-2"
              v-model="project.idc_printed_sheet"
            ></v-checkbox>
            <v-checkbox
              v-model="project.idc_workshop_exit_for_fitting"
              label="Finition essayage"
              class="mr-4 mt-2"
              hide-details
              disabled
            ></v-checkbox>
            <v-layout wrap>
              <v-checkbox
                hide-details
                label="Appareil terminé"
                class="mr-3 mt-2"
                v-model="project.idc_completed_device"
                disabled
              ></v-checkbox>
              <v-checkbox
                hide-details
                label="Appareil livré"
                class="mt-2"
                v-model="project.idc_device_delivery"
                disabled
              ></v-checkbox>
            </v-layout>
          </v-flex>
          <v-flex sm3 mx-8>
            <!-- Molded at -->
            <v-dialog v-model="dialog_molded" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.created_at | dateFormat"
                  label="Date moulage"
                  append-icon="mdi-calendar"
                  v-on="on"
                  disabled
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.created_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End Molded at -->

            <!-- Transfer at -->
            <v-dialog v-model="dialog_transfer" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.initial_transfer_at | dateFormat"
                  label="Date de transfert"
                  append-icon="mdi-calendar"
                  class="ma-0 pa-0"
                  v-on="on"
                  disabled
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.initial_transfer_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End Transfer at -->

            <!-- Currrent fitting at -->
            <v-dialog v-model="dialog_current_fitting" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.current_fitting | dateFormat"
                  label="Essayage Actuel"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.current_fitting = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.current_fitting"
              ></v-date-picker>
            </v-dialog>
            <!-- End currrent fitting at -->

            <!-- Fitting workshop 2 exit at -->
            <v-dialog v-model="dialog_workshop_exit2_at" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.workshop_exit2_at | dateFormat"
                  label="Sortie Atelier Essayage 2"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.workshop_exit2_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.workshop_exit2_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting workshop 1 exit at -->

            <!-- Fitting 1 at -->
            <v-dialog
              ref="dialog_fitting1"
              v-model="dialog_fitting1"
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting1_at | dateFormat"
                  label="Date essayage 1"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.fitting1_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting1_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting 1 at -->

            <!-- Fitting 2 at -->
            <v-dialog v-model="dialog_fitting2" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting2_at | dateFormat"
                  label="Date essayage 2"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  :disabled="!project.fitting1_at"
                  clearable
                  @click:clear="project.fitting2_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting2_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting 2 at -->

            <!-- Fitting 3 at -->
            <v-dialog v-model="dialog_fitting3" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting3_at | dateFormat"
                  label="Date essayage 3"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  :disabled="!project.fitting2_at"
                  clearable
                  @click:clear="project.fitting3_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting3_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting 3 at -->

            <!-- Planned delivery at -->
            <v-dialog v-model="dialog_planned_delivery" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.planned_delivery_at | dateFormat"
                  label="Livraison Prévue"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.planned_delivery_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.planned_delivery_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End planned delivery at -->
          </v-flex>
          <v-flex sm3>
            <!-- Molding arrival at -->
            <v-dialog v-model="dialog_molding_arrival" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.molding_arrival_at | dateFormat"
                  label="Arrivée du moulage"
                  append-icon="mdi-calendar"
                  v-on="on"
                  clearable
                  @click:clear="project.molding_arrival_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.molding_arrival_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End molding arrival at -->

            <!-- Workshop exit at -->
            <v-dialog
              ref="dialog_shipping"
              v-model="dialog_workshop_exit"
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.workshop_exit_at | dateFormat"
                  label="Sortie atelier Livraison"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.workshop_exit_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.workshop_exit_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End workshop exit at -->

            <!-- Fitting workshop 1 exit at -->
            <v-dialog v-model="dialog_workshop_exit1_at" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.workshop_exit1_at | dateFormat"
                  label="Sortie Atelier Essayage 1"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.workshop_exit1_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.workshop_exit1_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting workshop 1 exit at -->

            <!-- Fitting workshop 3 exit at -->
            <v-dialog v-model="dialog_workshop_exit3_at" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.workshop_exit3_at | dateFormat"
                  label="Sortie Atelier Essayage 3"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.workshop_exit3_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.workshop_exit3_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting workshop 1 exit at -->

            <!-- Fitting return 1 at -->
            <v-dialog v-model="dialog_fitting1_return" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting_return1_at | dateFormat"
                  label="Retour Essayage 1"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  :disabled="!project.fitting1_at"
                  clearable
                  @click:clear="project.fitting_return1_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting_return1_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting return 1 at -->

            <!-- Fitting return 2 at -->
            <v-dialog v-model="dialog_fitting2_return" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting_return2_at | dateFormat"
                  label="Retour Essayage 2"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  :disabled="!project.fitting2_at"
                  clearable
                  @click:clear="project.fitting_return2_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting_return2_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting return 2 at -->

            <!-- Fitting return 3 at -->
            <v-dialog v-model="dialog_fitting3_return" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.fitting_return3_at | dateFormat"
                  label="Retour Essayage 3"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  :disabled="!project.fitting3_at"
                  clearable
                  @click:clear="project.fitting_return3_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.fitting_return3_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End fitting return 3 at -->

            <!-- Real delivery at -->
            <v-dialog v-model="dialog_real_delivery" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.real_delivery_at | dateFormat"
                  label="Livraison réelle"
                  append-icon="mdi-calendar"
                  class="pa-0 ma-0"
                  v-on="on"
                  clearable
                  @click:clear="project.real_delivery_at = null"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.real_delivery_at"
              ></v-date-picker>
            </v-dialog>
            <!-- End real delivery at -->
          </v-flex>
        </v-layout>
        <div class="bloc-admin-container">
          <h2>BLOC ADMIN</h2>
          <v-layout justify-space-between wrap mt-4>
            <v-flex sm6>
              <v-layout class="checkbox-input-container">
                <v-flex sm6>
                  <v-checkbox
                    label="Non Affecté"
                    hide-details
                    v-model="project.idc_not_assigned"
                    @change="project.not_assigned = null"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm6 class="checkbox-input visible">
                  <v-select
                    v-model="project.not_assigned"
                    :items="selectItems"
                    hide-details
                    filled
                    clearable
                    :disabled="!project.idc_not_assigned"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout my-4 px-2 align-center>
                <p class="ma-0">Quantité Housse</p>
                <v-flex sm3 ml-4>
                  <InputNumber
                    v-model="project.cover_quantity"
                    class="input-number"
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex>
                  <v-checkbox
                    class="ma-0"
                    label="En commande"
                    v-model="project.idc_on_order"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-0"
                    label="Annulé"
                    hide-details
                    v-model="project.idc_cancelled"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    class="ma-0"
                    label="Demande d’entente faite"
                    hide-details
                    v-model="project.idc_request_agreement_made"
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-0"
                    label="Prescription manquante"
                    hide-details
                    v-model="project.idc_prescription_missing"
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-0"
                    label="Urgence / Post OP"
                    hide-details
                    v-model="project.idc_emergency_post_op"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-textarea
              filled
              name="Commentaire"
              label="Commentaire"
              value
              rows="5"
              hide-details
              class="mt-2"
              v-model="project.comment"
            ></v-textarea>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "GeneralTab",
    components: {
      InputNumber: () => import("@/components/InputNumber"),
      ArticlesTable: () => import("./ArticlesTable")
    },
    props: {
      project: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        headers: [
          {
            text: "Traiter",
            sortable: true,
            value: "patient"
          },
          {
            text: "Lpp",
            sortable: true,
            value: "type"
          },
          {
            text: "Qté",
            sortable: true,
            value: "created_at"
          },
          {
            text: "Total HT",
            sortable: true,
            value: "transferred_at"
          }
        ],

        selectItems: [
          {
            text: "En attente accord",
            value: "PENDING_AGREEMENT"
          },
          {
            text: "Devis",
            value: "QUOTATION"
          },
          {
            text: "En attente couleurs",
            value: "PENDING_COLORS"
          },
          {
            text: "Autre",
            value: "OTHER"
          }
        ],

        // Date pickers modals
        dialog_molded: false,
        dialog_transfer: false,
        dialog_current_fitting: false,
        dialog_fitting1: false,
        dialog_fitting2: false,
        dialog_fitting3: false,
        dialog_molding_arrival: false,
        dialog_workshop_exit1_at: false,
        dialog_workshop_exit2_at: false,
        dialog_workshop_exit3_at: false,
        dialog_fitting1_return: false,
        dialog_fitting2_return: false,
        dialog_fitting3_return: false,
        dialog_workshop_exit: false,
        dialog_planned_delivery: false,
        dialog_real_delivery: false
      };
    }
  };
</script>

<style></style>
